import type { TablePiece } from '@v2/sdk'

/** Secret front metadata is never a fallback for a face-down component. */
export function pieceLabel(piece: TablePiece): string {
  return piece.hidden ? piece.back?.title ?? 'Face-down card' : piece.label
}
